import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchVaMix, type VaMixTeam } from '../services/vaMonitoringOverview';
import { MONITORING_OVERVIEW_VA_MIX_KEY } from './queryKeys';

const MIX_STALE_MS = 5 * 60_000;

export function useMonitoringVaMix(team: VaMixTeam) {
    const { data, isPending, isFetching, isError, isPlaceholderData, refetch } = useQuery({
        queryKey: MONITORING_OVERVIEW_VA_MIX_KEY(team),
        queryFn: () => fetchVaMix(team),
        staleTime: MIX_STALE_MS,
        placeholderData: keepPreviousData
    });
    return {
        data: data ?? null,
        isLoading: isPending,
        isSwitching: isFetching && isPlaceholderData,
        isError,
        retry: refetch
    };
}
